export default __webpack_public_path__ + "static/media/selamat5.3639d8f6.svg";